import * as PropTypes from 'prop-types';
import * as React from 'react';
import { HashUtil } from '@reverbdotcom/discovery-ui';

class UserNotification extends React.Component {
  getLink() {
    const link = HashUtil.getSafely(this.props, 'data.notification_links.web.href');
    if (!link) { return; }

    // Remove domain to preseve ORIGIN for admin.reverb.tools
    const loc = new URL(link);
    return loc.pathname + loc.search + loc.hash;
  }

  render() {
    return (
      <li>
        <a
          className="site-header__menu__link site-header__menu__link--new-feature"
          href={this.getLink()}
          target="_blank"
          rel="noopener noreferrer"
        >
          {this.props.data.title}
          <span className="site-header__menu__link-subtitle">
            {this.props.data.description}
          </span>
        </a>
      </li>
    );
  }
}

UserNotification.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    notification_links: PropTypes.shape({
      web: PropTypes.shape({
        href: PropTypes.string.isRequired,
      })
    }).isRequired,
  })
};


export default UserNotification;



// WEBPACK FOOTER //
// ./javascripts/components/user_notification.jsx